import { Col, Tappable, Text, useTheme } from "@rally/ui-kit";

import { say } from "../localization/say.ts";
import type { Filter } from "./found.ts";

export function Filters({ selected, onSelect }: { selected: Filter; onSelect: (filter: Filter) => void }) {
  const theme = useTheme();
  const filters: Array<{ id: Filter; label: string }> = [
    { id: "all", label: say("find.all") },
    { id: "conversations", label: say("find.conversations") },
    { id: "messages", label: say("find.messages") },
    { id: "files", label: say("find.files") },
    { id: "people", label: say("find.people") },
    { id: "agents", label: say("find.agents") },
    { id: "apps", label: say("find.apps") },
    { id: "repositories", label: say("find.repos") },
  ];
  return (
    <Col
      testID="find-filters"
      style={{
        flexDirection: "row",
        flexWrap: "wrap",
        gap: theme.space[1],
        paddingHorizontal: theme.space[3],
        paddingVertical: theme.space[2],
      }}
    >
      {filters.map((filter) => {
        const on = filter.id === selected;
        return (
          <Tappable
            key={filter.id}
            onPress={() => onSelect(filter.id)}
            accessibilityRole="button"
            accessibilityState={{ selected: on }}
            aria-pressed={on}
            testID={`find-filter-${filter.id}`}
            style={{
              minHeight: 44,
              minWidth: 44,
              justifyContent: "center",
              paddingVertical: theme.space[1],
              paddingHorizontal: theme.space[2],
              borderRadius: 999,
              borderWidth: 1,
              borderColor: on ? theme.color.accent : theme.color["border.default"],
              backgroundColor: on ? theme.color.accent : "transparent",
            }}
          >
            <Text typeName="caption" color={on ? "text.onAccent" : "text.secondary"}>
              {filter.label}
            </Text>
          </Tappable>
        );
      })}
    </Col>
  );
}
